import { Box, Stack } from '@mui/material';
import { Faq } from '@/pages/public/pricing/Faq';
import PlanCardUnified from '@/components/PlanCardUnified';

export function Plans({ plansData }) {
	return (
		<Box pt="20px">
			<Stack
				sx={{
					flexDirection: { xs: 'column', sm: 'row' },
					alignItems: 'flex-start',
					gap: { xs: '20px', md: '16px' },
					mb: 5
				}}
			>
				<PlanCardUnified plansData={plansData} isBilling />
			</Stack>
			<Faq />
		</Box>
	);
}
